export default "__VITE_ASSET__27eEwboe__"